import { Component, OnInit } from '@angular/core';
import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { MatRippleModule } from '@angular/material/core';
import { Router, RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { inject } from '@angular/core';
import { AuthService, guestUser } from 'src/service/auth/auth.service';
import { NavigationLoaderService } from 'src/app/core/navigation/navigation-loader.service';


@Component({
  selector: 'vex-sidenav-user-menu',
  templateUrl: './sidenav-user-menu.component.html',
  styleUrls: ['./sidenav-user-menu.component.scss'],
  imports: [MatRippleModule, RouterLink, MatIconModule],
  standalone: true
})
export class SidenavUserMenuComponent implements OnInit {
  private authService: AuthService
  private _navLoaderSvc: NavigationLoaderService;
  private router: Router;
  constructor(private readonly popoverRef: VexPopoverRef) {
     this.authService = inject(AuthService);
     this._navLoaderSvc = inject(NavigationLoaderService)
     this.router = inject(Router);
     
  }

  ngOnInit(): void {
  }

  close(): void {
    /** Wait for animation to complete and then close */
    this._navLoaderSvc.loadNavigation();
    this.router.navigate(['/login']);

    setTimeout(() => this.popoverRef.close(), 250);
    console.log ("Close called")
  }

  logout(): void {
    this.authService.logOutUser().subscribe({
      next: (response) => {
        console.log("Logout response: ", response)
        if (response) {
          this.authService.loggedInUser = guestUser;
          localStorage.removeItem("loggedInUser")
        } else {
          console.error("Logout failed");
        }
        console.log ("logout called")
        this.close()    
      },
      error: (error) => {
        console.error("Error during logout: ", error);
        console.log ("logout called")
        this.router.navigate(['/login']);
        this.close()
        }
    
    });
    console.log ("logout called")
    this.close()
  }
}
